module.exports = __webpack_public_path__ + "static/img/quick_link06.34106304.png";